import { Component, OnInit } from '@angular/core';
import { ScreenManagerService } from '@mpt-fo/common/core/services/screen-manager.service';
import { ProfileSetupService } from '@mpt-fo/common/core/services/profile-setup/profile-setup.service';
import { ModalType } from '@mpt-fo/common/kamona/model/kamonal-model';

@Component({
    selector: 'app-sign-in',
    templateUrl: './sign-in.component.html',
    styleUrls: ['./sign-in.component.scss'],
})
export class SignInComponent implements OnInit {
    mobile: boolean;
    modal: boolean;
    modalType = ModalType.CUSTOM;
    termsAndConditions: any;
    customModal: 'TERMS_AND_CONDITION' | 'PRIVACY';
    PRIVACY: 'PRIVACY' = 'PRIVACY';
    constructor(private screenManager: ScreenManagerService, private profileService: ProfileSetupService) {}

    ngOnInit(): void {
        this.mobile = this.screenManager.isMobile();
        this.screenManager.isMobile$.subscribe((mobile: boolean) => {
            this.mobile = mobile;
        });
    }

    async initialize() {
        this.profileService.login();

        if (!this.termsAndConditions) await this.getTermsAndConditions();
    }

    signup() {
        this.profileService.createAccount();
    }

    openPrivacy() {
        this.customModal = 'PRIVACY';
        this.isModal(true);
    }

    openTermsAndConditions() {
        this.customModal = 'TERMS_AND_CONDITION';
        this.isModal(true);
    }

    isModal(modal: boolean) {
        this.modal = modal;
    }

    closeCustomModal() {
        this.isModal(false);
    }

    async getTermsAndConditions() {
        this.termsAndConditions = await this.profileService.termsAndConditions();
    }
}
